import React from "react";

import ToggleButton from "./ToggleButton.tsx";

// For backward compatibility - this maintains the original component API
interface WordButtonProps {
  isSaved: boolean;
  onClick: () => void;
}

const AddPhraseButton: React.FC<WordButtonProps> = ({
  isSaved: isKnown,
  onClick,
}) => {
  return (
    <ToggleButton
      isActive={isKnown}
      activeText="Phrase Saved"
      inactiveText="Save Phrase"
      onClick={onClick}
    />
  );
};

export default AddPhraseButton;
